export default "__VITE_ASSET__D6J7leLS__$_?url__"